// extracted by mini-css-extract-plugin
export var orderSummary = "_jp-0";
export var showMoreLessButton = "_jp-1";